module.exports = __webpack_public_path__ + "img/salud.fd24e248.svg";